"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPlan = checkPlan;

var _checks = require("../../checks");

var _formatErrors = _interopRequireDefault(require("../../utilities/formatErrors"));

var _copyContent = _interopRequireDefault(require("../../data/copyContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkTargetSample(integer, message) {
  if (integer === null || integer === undefined) return true;
  const hasDecimal = integer - Math.floor(integer) !== 0;
  if (hasDecimal) return message;
  return Number.isInteger(integer) && integer > 0 && integer <= 8000000000 ? true : message;
}
/*
*  Checks Experiment Plan
*  Expected GQL Shape:
*
*  experiment(id: $id) {
      name
      summary
      hypothesis
      durationNumDays
      experimentTypeId
      productToFeature {
        productId
        productFeatureId
      }
    }
*/


function checkPlan(experiment) {
  const {
    name,
    summary,
    hypothesis,
    targetSampleSize,
    durationNumDays,
    experimentTypeId,
    productToFeature,
    isCMSExperiment
  } = experiment;
  const {
    plan: {
      lengthLimitError,
      missingProduct,
      missingFeature,
      missingName,
      targetSampleSizeNotNumber,
      missingLength,
      missingType,
      minimumCharacterError
    }
  } = _copyContent.default;
  const checks = {
    name: (0, _checks.checkString)(name, missingName),
    summary: (0, _checks.checkString)(summary, minimumCharacterError('summary'), 35),
    hypothesis: (0, _checks.checkString)(hypothesis, minimumCharacterError('hypothesis'), 35),
    targetSampleSize: checkTargetSample(targetSampleSize, targetSampleSizeNotNumber),
    durationNumDays: (0, _checks.checkInteger)(durationNumDays, missingLength),
    experimentType: (0, _checks.checkInteger)(experimentTypeId, missingType)
  };

  if (checks.durationNumDays === true) {
    checks.durationNumDays = (0, _checks.checkIntegerRange)(durationNumDays, 1, 180, lengthLimitError);
  }

  if (!productToFeature) {
    checks.product = missingProduct;
    checks.feature = missingFeature;
  } else {
    const {
      productId,
      productFeatureId
    } = productToFeature;
    checks.product = (0, _checks.checkInteger)(productId, missingProduct);
    checks.feature = !isCMSExperiment ? (0, _checks.checkInteger)(productFeatureId, missingFeature) : true;
  }

  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}